import React from 'react';
import { Container, Grid, Card, CardContent, Typography,IconButton, Tooltip } from '@mui/material';
import DonutChart from './PieChart';
import BarChart from './BarChart';
import CostOptimizationGrid from './CostOptimizationGrid';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos'
import { useNavigate } from 'react-router'

const CostOptimizationChart = ({
  accountDetails,
  smallVersion, onBackClick // Prop to indicate small version
}) => {
  const {
    accountId,
    accountName,
    forecastedCost,
    totalPotentialSavings,
    servicePercentages,
    serviceSet,
  } = accountDetails || {};

  const navigate=useNavigate();

 
  // const filteredRowData = rowData.filter(row => row.accountId === accountId);

  // Check if servicePercentages contains NaN or invalid values
  const isServiceDataValid = (servicePercentages) => {
    if (!servicePercentages) return false;
  
    // Check if all values in servicePercentages are valid numbers and greater than 0
    return Object.values(servicePercentages).every(value => {
      const parsedValue = parseFloat(value);
      return !isNaN(parsedValue) && parsedValue > 0;
    });
  };

  // Define chart and card height based on smallVersion prop
  const chartHeight = smallVersion ? '130px' : '200px';
  const barChartHeight = smallVersion ? '40px' : '140px';
  const cardHeight = smallVersion ? '122px' : '260px'; // Ensure each card fits within the desired height
  const smallCardHeight = smallVersion ? '40px' : '140px'; // Height for smaller cards within the main card
  const donutChartHeight = smallVersion ? '40px' : '140px';

  // Define font size based on smallVersion prop
  const typographyVariant = smallVersion ? 'body2' : 'h6';
  const typographyBodySize = smallVersion ? '0.75rem' : '1rem'; // Smaller font size for smallVersion

  // Define inline styles
  const inlineStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    padding: smallVersion ? '5px' : '10px', // Adjust padding based on version
  };

  return (
    <div>
    <div style={{ padding: 0 }} >
      <Grid container spacing={2}>
        { onBackClick && !smallVersion &&
(<Grid item xs={12}>
  <div>
    <Tooltip title='Back'>
    <IconButton onClick={onBackClick}>
        <ArrowBackIosIcon/>
    </IconButton>
    </Tooltip>
  </div>
</Grid>)
        }
      
        {/* First Row: Combined Account Details Card, and Donut Chart */}
        <Grid item xs={12} md={6}>
          <Card style={{ margin: '0px', height: smallVersion ? '120px' : '260px' }}>
            <CardContent>
              <Grid container spacing={1}>
                {/* Account ID */}
                <Grid item xs={12}>
                  <Card style={{ height: smallVersion ? '45px' : '110px' }}>
                    <CardContent style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                      {smallVersion ? (
                        <div style={inlineStyle}>
                          <Typography variant={typographyVariant} style={{  fontWeight: 'bold', textAlign:'center' }}>
                            Account ID:
                          </Typography>
                          <Typography variant={typographyVariant} style={{  }}>
                            {accountId}
                          </Typography>
                        </div>
                      ) : (
                        <>
                          <Typography variant={typographyVariant} style={{ fontWeight: 'bold' }}>
                            Account ID
                          </Typography>
                          <Typography variant={typographyVariant} style={{ fontSize: typographyBodySize }}>
                            {accountId}
                          </Typography>
                        </>
                      )}
                    </CardContent>
                  </Card>
                </Grid>
                {/* Account Name */}
                <Grid item xs={12}>
                  <Card style={{ height: smallVersion ? '40px' : '110px' }}>
                    <CardContent style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                      {smallVersion ? (
                        <div style={inlineStyle}>
                          <Typography variant={typographyVariant} style={{ fontWeight: 'bold' }}>
                            Account Name:
                          </Typography>
                          <Typography variant={typographyVariant} style={{ fontSize: typographyBodySize }}>
                            {accountName}
                          </Typography>
                        </div>
                      ) : (
                        <>
                          <Typography variant={typographyVariant} style={{fontWeight: 'bold' }}>
                            Account Name
                          </Typography>
                          <Typography variant={typographyVariant} style={{ fontSize: typographyBodySize }}>
                            {accountName}
                          </Typography>
                        </>
                      )}
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={6}>
          <Card style={{ margin: '0px', height: cardHeight }}>
            <CardContent>
              <Typography variant={typographyVariant} gutterBottom>By Service (%)</Typography>
              <div style={{ height: donutChartHeight }}>
                {isServiceDataValid ? (
                  <DonutChart servicePercentages={servicePercentages} serviceSet={serviceSet} smallVersion={smallVersion} />
                ) : (
                  <Typography variant={typographyVariant} style={{ fontSize: typographyBodySize }}>No data available</Typography>
                )}
              </div>
            </CardContent>
          </Card>
        </Grid>

        {/* Second Row: Bar Chart and Cost Optimization Grid */}
        <Grid item xs={12} md={6}>
          <Card style={{ margin: '0px', height: cardHeight }}>
            <CardContent>
            <Typography variant={typographyVariant} style={{}} gutterBottom>
                Forecasted Cost : ${forecastedCost ? forecastedCost.toFixed(2) : '0.00'}
              </Typography>
              <Typography variant={typographyVariant} gutterBottom>
                Total Potential Saving : ${totalPotentialSavings ? totalPotentialSavings.toFixed(2) : '0.00'}
              </Typography>
              <div style={{ height: barChartHeight }}>
                {forecastedCost && totalPotentialSavings ? (
                  <BarChart forecastedCost={forecastedCost} totalPotentialSavings={totalPotentialSavings} smallVersion={smallVersion} />
                ) : (
                  <Typography variant={typographyVariant} style={{ fontSize: typographyBodySize }}>No data available</Typography>
                )}
              </div>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={6}>
          <Card style={{ margin: '0px', height: cardHeight }}>
            <CardContent>
              <CostOptimizationGrid
                services={accountDetails.services}
                smallVersion={smallVersion}
              />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </div>
    </div>
  );
};

export default CostOptimizationChart;
